import type { ErrorMap } from '@/app/error-registry';

/**
 * `Whiteboard.NotFound` covers four backend cases at once — missing, soft-deleted, other
 * tenant, or no project membership — deliberately, so a 404 never confirms that a resource
 * exists elsewhere. One message for all of them.
 *
 * The PUT entries only matter as a safety net: `compactSnapshot` sends `skipGlobalError`,
 * because `Whiteboard.SnapshotStale` just means another client compacted first.
 */
export const WHITEBOARDS_ERROR_MAP: ErrorMap = {
  POST: {
    'Whiteboard.NameRequired': 'whiteboards:apiErrors.nameRequired',
    'Whiteboard.NameTooLong': 'whiteboards:apiErrors.nameTooLong',
    // On create there is no whiteboard to be missing yet: the same code means the board could
    // not be resolved, or the caller is not a member of its project.
    'Whiteboard.NotFound': 'whiteboards:apiErrors.boardNotFound',
    default: 'whiteboards:apiErrors.createDefault',
  },
  PATCH: {
    'Whiteboard.NameRequired': 'whiteboards:apiErrors.nameRequired',
    'Whiteboard.NameTooLong': 'whiteboards:apiErrors.nameTooLong',
    'Whiteboard.NotFound': 'whiteboards:apiErrors.notFound',
    default: 'whiteboards:apiErrors.renameDefault',
  },
  DELETE: {
    'Whiteboard.NotFound': 'whiteboards:apiErrors.notFound',
    default: 'whiteboards:apiErrors.deleteDefault',
  },
  PUT: {
    'Whiteboard.SnapshotStale': 'whiteboards:apiErrors.snapshotStale',
    'Whiteboard.CoversSeqInvalid': 'whiteboards:apiErrors.snapshotDefault',
    'Whiteboard.InvalidSnapshotEncoding': 'whiteboards:apiErrors.snapshotDefault',
    default: 'whiteboards:apiErrors.snapshotDefault',
  },
};
